import { LOGIN_SUCCESS, LOGIN_FAIL, ADMIN_LOADED, AUTH_FAIL, LOGOUT, ADMIN_UPDATE_REQUEST, ADMIN_UPDATE_SUCCESS, ADMIN_UPDATE_FAIL } from '../type/type';

const initialState = {
  token: localStorage.getItem('tokenAdmin'),
  isAuthenticated: localStorage.getItem('tokenAdmin') ? true : false,
  loading: true,
  updateLoading: false,
  user: null,
  error: null
};

export default function authReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: true,
      };
    case ADMIN_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload.admin, // assuming payload.admin exists
      };
    case AUTH_FAIL:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem('tokenAdmin');
      return { ...state, isAuthenticated: false, loading: false, user: null };
    default:
      return state;
  }
}
